import React from 'react';
import WorkbenchHistoryButton from './WorkbenchHistoryButton';
import WorkbenchManualLink from './WorkbenchManualLink';

/**
 * 工作台工具侧栏统一头部：标题行，可选全宽或标题行内紧凑「使用教程」。
 *
 * @param {'full'|'headerButton'} [manualPlacement='full'] - full 为标题下全宽教程块；headerButton 为历史记录右侧按钮
 */
export default function WorkbenchStudioSidebarHead({
  title,
  subtitle,
  navId,
  historyScopeId,
  onHistoryClick,
  historyActive = false,
  historyLabel,
  historyClassName,
  manualPlacement = 'full',
}) {
  const scopeId = historyScopeId || navId;
  const showHeaderManual = navId && manualPlacement === 'headerButton';
  const showFullManual = navId && manualPlacement === 'full';
  const showHistory = typeof onHistoryClick === 'function' && scopeId;

  return (
    <header className="img2img-studio__sidebar-head">
      <div className="img2img-studio__sidebar-head-row">
        <div className="img2img-studio__title-block">
          <h1 className="img2img-studio__title">{title}</h1>
          {subtitle ? <p className="img2img-studio__subtitle">{subtitle}</p> : null}
        </div>
        {showHistory || showHeaderManual ? (
          <div className="img2img-studio__sidebar-head-actions">
            {showHeaderManual ? (
              <WorkbenchManualLink navId={navId} variant="button" className="img2img-studio__history-btn" />
            ) : null}
            {showHistory ? (
              <WorkbenchHistoryButton
                scopeId={scopeId}
                onClick={onHistoryClick}
                active={historyActive}
                {...(historyLabel ? { label: historyLabel } : {})}
                {...(historyClassName ? { className: historyClassName } : {})}
              />
            ) : null}
          </div>
        ) : null}
      </div>
      {showFullManual ? (
        <WorkbenchManualLink navId={navId} className="workbench-manual-link--full" />
      ) : null}
    </header>
  );
}
